module.exports = __webpack_public_path__ + "static/media/no-signatures.4cbaac06.svg";